import { FC, useEffect } from "react";
import { PageWrapper } from "@connectedComponents";
import { 
    AverageSalesByDayChart, AverageSalesByHourChart, 
    RevenueOverview, SellerPerformance, TopProducts,
} from "./components";
import { useAllowedAccess, useDashboard, useSubscriptions } from "@utilities/hooks";
import { Card, MonthlyRevenueProgression } from "@components";

export const Dashboard: FC = () => {

    useAllowedAccess();
    const {
        yearSalesByMonth, monthSalesByWeek,
        weekSalesByDay, todaySalesByHour,
        topProductsStats, averageSalesByHour,
        averageSalesByDayOfWeek, sellerPerformance,
        organisationMontlyRevenue, getOrganisationMontlyRevenueError,
        getYearSalesByMonthError, getMonthSalesByWeekError,
        getWeekSalesByDayError, getTodaySalesByHourError,
        getTopProductsStatsError, getAverageSalesByHourError,
        getAverageSalesByDayOfWeekError, getSellerPerformanceError,
        fetchAllDashboardData,
    } = useDashboard();

    const {
        plans, onGetAllPlans
    } = useSubscriptions();

    useEffect(()=> {
        fetchAllDashboardData();
        onGetAllPlans();
    }, []);

    return (
        <PageWrapper activeStack='dashboardStack'>
            <div className="flex flex-col gap-8">
                <MonthlyRevenueProgression 
                    plans={plans}
                    monthlyRevenue={organisationMontlyRevenue?.totalRevenue || 0} 
                    nextInvoiceDate={organisationMontlyRevenue?.nextInvoiceDate || new Date()}    
                />

                <Card
                    title="Aperçu des revenus"
                >
                    <RevenueOverview
                        todaySalesByHour={todaySalesByHour}
                        weekSalesByDay={weekSalesByDay}
                        monthSalesByWeek={monthSalesByWeek}
                        yearSalesByMonth={yearSalesByMonth}
                    />
                </Card>

                <Card
                    title="Produits les plus vendus"
                >
                    <TopProducts data={topProductsStats} />
                </Card>

                <Card
                    title="Ventes moyennes par heure"
                >
                    <AverageSalesByHourChart data={averageSalesByHour} />
                </Card>

                <Card
                    title="Ventes moyennes par jour"
                >
                    <AverageSalesByDayChart data={averageSalesByDayOfWeek} />
                </Card>

                <Card
                    title="Performance des vendeurs"
                >
                    <SellerPerformance
                        data={sellerPerformance}
                        onDateRangeChange={(startDate, endDate) => {
                            // fetchSellerPerformance({ startDate, endDate });
                        }}
                    />
                </Card>
            </div>
        </PageWrapper>
    )
}
